import { httpClient } from "../funcs";
import { notifyAboutError } from "../methods/notifyUser";

export async function loadRoles(userId: string, props?: any) {
    try {
        const { data } = await httpClient.get('/get-user-list');
        const users = data.users.filter((user: any) => user.type === 'user');
        
        // Находим текущего пользователя
        const currentUser = users.find((user: any) => user._id === userId);
        const currentUserPhone = currentUser?.phone_number;

        const grantedByYouRoles = data.users.filter((user: any) => 
            user.type === 'role' && user.granted_by?._id === userId
        );

        const grantedToYouRoles = data.users.filter((user: any) => 
            user.type === 'role' && (
                user.granted_to?._id === userId || 
                (currentUserPhone && user.granted_to_phone_number === currentUserPhone)
            )
        );

        return {
            users,
            grantedByYouRoles,
            grantedToYouRoles,
            currentUserId: data.current_user_id,
            myUserId: data.my_user_id
        };
    } catch (error) {
        if (props) {
            notifyAboutError(props, error);
        }
        return {
            users: [],
            grantedByYouRoles: [],
            grantedToYouRoles: [],
            currentUserId: null,
            myUserId: null
        };
    }
}

export function getBusinessRole(grantedToYouRoles: any[]) {
    return grantedToYouRoles.find((role: any) => role.status === 'CONFIRMED');
}